<template>
    <div class="notice-container">{{noticeText}}</div>
</template>

<script type="text/javascript">
import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState([
            'noticeText'
        ])
    }
}
</script>